/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: f7c9ee0efde58a344baff1967cc92df3b2d9e9d93f049f380ed66d2a7c3779fb
 */
import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  base_contentBackground,
  grey100,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import {
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: 320px;

  .header {
    align-items: center;
    background: ${base_colorSurfaceSecondary};
    border-bottom-color: ${base_colorContentBorder};
    border-bottom-style: solid;
    border-bottom-width: 1px;
    display: flex;
    flex-shrink: 0;
    height: 42px;
    padding-block: ${spacing(3)};
    padding-inline: 20px;
    width: 100%;
  }

  .search {
    align-items: center;
    background: ${grey100};
    border-bottom-color: ${base_colorContentBorder};
    border-bottom-style: solid;
    border-bottom-width: 1px;
    display: flex;
    flex-shrink: 0;
    gap: 14px;
    height: 50px;
    padding-inline-end: 20px;
    padding-inline-start: 16px;
    width: 100%;
  }

  .content {
    align-items: flex-start;
    background: ${base_contentBackground};
    display: flex;
    flex-direction: column;
    overflow: clip;
    padding-block: ${spacing(2)};
    width: 100%;
  }

  .emptyState {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    padding-bottom: 90px;
    padding-inline: 20px;
    padding-top: 48px;
    text-align: center;
    width: 100%;
  }

  .emptyTitle {
    color: ${text_colorTextPrimary};
    font-size: ${font_size_md};
    font-family: ${font_family_weight_medium};
    line-height: 18px;
    width: 100%;
  }

  .emptyDescription {
    color: ${text_colorTextPrimary};
    font-size: ${font_size_md};
    font-family: ${font_family_weight_regular};
    line-height: 18px;
    width: 100%;
  }

  .footer {
    align-items: center;
    background: ${base_colorSurfaceSecondary};
    border-top-color: ${base_colorContentBorder};
    border-top-style: solid;
    border-top-width: 1px;
    display: flex;
    height: 42px;
    justify-content: flex-end;
    padding-block: ${spacing(3)};
    padding-inline: 20px;
  }

  &.isFooterAbsolute {
    max-height: 320px;
  }

  &.isFooterAbsolute .content {
    max-height: 320px;
    position: relative;
  }

  &.isFooterAbsolute .footer {
    bottom: -1px;
    left: -1px;
    position: absolute;
    width: 320px;
  }

  &.not-isFooterAbsolute .footer {
    flex-shrink: 0;
    width: 100%;
  }
`
